module.exports = "<p>\n  internal works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/issues/internal/internal.component.html
// module id = ./src/app/issues/internal/internal.component.html
// module chunks = main